export default {
  'productiveHoursSold.label.filterDate': 'Filtrar por data de',
  'productiveHoursSold.label.status': 'Situação',
  'productiveHoursSold.label.reportType': 'Selecionar o tipo de relatório',
  'productiveHoursSold.label.workingDays': 'Dias úteis por mês',
  'productiveHoursSold.label.hoursWorked': 'Horas trabalhadas por dia',
  'productiveHoursSold.label.moreOptions': 'Mais Opções',
  'productiveHoursSold.label.type': 'Tipo',
  'productiveHoursSold.label.employees': 'Funcionários',
  'productiveHoursSold.label.area': 'Área',

  'productiveHoursSold.option.input': 'Entrada',
  'productiveHoursSold.option.authorization': 'Autorização',
  'productiveHoursSold.option.closure': 'Fechamento',
  'productiveHoursSold.option.exit': 'Saída',
  'productiveHoursSold.option.open': 'Abertos',
  'productiveHoursSold.option.authorized': 'Autorizados',
  'productiveHoursSold.option.closed': 'Fechados',
  'productiveHoursSold.option.canceled': 'Cancelados',
  'productiveHoursSold.option.perEmployee': 'Por Funcionários',
  'productiveHoursSold.option.byArea': 'Por Área',
  'productiveHoursSold.option.budget': 'Orçamento',
  'productiveHoursSold.option.warranty': 'Garantia',
  'productiveHoursSold.option.return': 'Retorno',
  'productiveHoursSold.option.courtesy': 'Cortesia',
  'productiveHoursSold.option.insideCourtesy': 'Interna (Cortesia)',
  'productiveHoursSold.option.totalLoss': 'Perda Total',
  'productiveHoursSold.option.revision': 'Revisão',

  'productiveHoursSold.checkbox.inhibitArea':
    'Inibir média área e valores do relatório',
  'productiveHoursSold.checkbox.viewModel':
    'Visualizar modelo e versão do relatório',
};
